import { useTranslation } from 'react-i18next';

import type { CreditNote } from '~/api/creditNotes/types';

import { Tooltip } from '~/components';

import { CreditNoteStatusTag } from '../CreditNoteStatusTag';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteStatusCell = ({ creditNote }: Props) => {
  const { t } = useTranslation(['creditnotes']);

  const isSentWithPeppol = creditNote.status === 'Approved' && creditNote.coTransportType === 'Peppol';

  return (
    <Tooltip content={isSentWithPeppol ? t('creditnotes:overview.columns.status.sentWithPeppolTooltip') : null} disableHoverablePopup>
      <CreditNoteStatusTag status={creditNote.status} />
    </Tooltip>
  );
};
